<template>

  <section class="section-video">
    <ExpanderResourceSetVideo :videoId="resourcesVideoId" :mobile="mobile" />
  </section>

  <section class="section-main">
    <h1 class="heading">Vi introduserer vår<br>første elektriske SUV noensinne</h1>
    <div class="image">
      <img src="@/assets/image-1.jpg">
    </div>
  </section>

  <section class="section-usp">
    <div class="item">
      <span class="title">Maks effekt</span>
      <span class="value">204&nbsp;<span class="unit">hk</span></span>
    </div>
    <div class="item">
      <span class="title">Maks dreiemoment</span>
      <span class="value">315&nbsp;<span class="unit">Nm</span></span>
    </div>
    <div class="item">
      <span class="title">Akselerer 0-100 km/t (fra)</span>
      <span class="value">7,6&nbsp;<span class="unit">sek</span></span>
    </div>
    <div class="item">
      <span class="title">0-100 km ladning med 100kW&nbsp;lader</span>
      <span class="value">11&nbsp;<span class="unit">min</span></span>
    </div>
  </section>

  <section class="section-color">
    <ExpanderColorSelector @track="track" />
  </section>
     
  <section class="section-tiles">
    <div class="tile">
      <div class="text">
        <h2 class="title">Utforsk de innvendige funksjonene til e:Ny1</h2>
        <p>Den romslige kupeen fremheves av et stort panoramaglasstak*, noe som gjør kupeen mer åpen og innbydende for både fører og passasjerer.</p>
        <p class="note">
          *Gjelder kun utvalgte modeller
        </p>
        <a href="https://www.honda.no/cars/new/e-ny1-electric-suv/features.html?utm_source=showheroes&utm_medium=video&utm_campaign=eny1_launch" target="_blank" class="cta" @click="track('oppdag-alle-funksjonene')">Oppdag alle funksjonene</a>
      </div>
      <a href="https://www.honda.no/cars/new/e-ny1-electric-suv/features.html?utm_source=showheroes&utm_medium=video&utm_campaign=eny1_launch" target="_blank" class="image" @click="track('image')">
        <img src="@/assets/image-2.jpg">
      </a>
    </div>
    <div class="tile">
      <div class="text">
        <h2 class="title">Fullpakket med teknologi</h2>
        <p>e:Ny1 har et sjenerøst 15,1" Honda CONNECT infotainmentsystem som gir deg full kontroll over infotainment- og kjørefunksjonene dine – fra navigasjon, apper og ryggekamera, til lyd og klimakontroll.</p>
        <a href="https://www.honda.no/cars/new/e-ny1-electric-suv/features.html?utm_source=showheroes&utm_medium=video&utm_campaign=eny1_launch" target="_blank" class="cta" @click="track('oppdag-alle-funksjonene')">Oppdag alle funksjonene</a>
      </div>
      <a href="https://www.honda.no/cars/new/e-ny1-electric-suv/features.html?utm_source=showheroes&utm_medium=video&utm_campaign=eny1_launch" target="_blank" class="image" @click="track('image')">
        <img src="@/assets/image-3.jpg">
      </a>
    </div>
  </section>

  <section class="section-info">
    <h1 class="heading">Den smarte, stilige SUV-en, med jevn elektrisk ytelse</h1>
    <div class="items">
      <a href="https://www.honda.no/cars/get-a-brochure.html?utm_source=showheroes&utm_medium=video&utm_campaign=eny1_launch&utm_content=brosjyre" target="_blank" class="cta download" @click="track('download-brosjyre')">Download brosjyre</a>
      <a href="https://www.honda.no/cars/find-a-dealer.html?utm_source=showheroes&utm_medium=video&utm_campaign=eny1_launch&utm_content=finn_forhandler" target="_blank" class="cta find" @click="track('finn-en-forhandler')">Finn en forhandler</a>
      <a href="https://www.honda.no/cars/book-a-test-drive.html?utm_source=showheroes&utm_medium=video&utm_campaign=eny1_launch&utm_content=book_provekjoring" target="_blank" class="cta book" @click="track('book-prøvekjøring')">Book prøvekjøring</a>
    </div>
  </section>

  <footer class="section-footer sticky">
    <div class="container">
      <a href="https://www.honda.no/cars/new/e-ny1-electric-suv/overview.html" target="_blank" class="logo" @click="track('logo')">
        <img src="@/assets/honda.png">
      </a> 
      <!-- <a href="https://www.honda.no/cars/new/e-ny1-electric-suv/overview.html" target="_blank" class="cta" @click="track('les-mer')">Les mer om <img src="@/assets/eNy1-Logo-2D_Black_Transparent_background.png" alt="e:Ny1"></a> -->
      <a href="https://www.honda.no/cars/new/e-ny1-electric-suv/overview.html" target="_blank" class="model" @click="track('e:ny1')"><img src="@/assets/eNy1-Logo-2D_Black_Transparent_background.png" alt="e:Ny1"></a>
    </div>
  </footer>


</template>

<script>
  import ExpanderResourceSetVideo from './components/ExpanderResourceSetVideo.vue'
  import ExpanderColorSelector from './components/ExpanderColorSelector.vue'

  export default {
    name: 'App',
    components: {
      ExpanderResourceSetVideo,
      ExpanderColorSelector,
    },
    data() {
      return {
        resourcesId: 2212,
        resourcesVideoId: 3449,
        version: 1,
        mobile: false
      }
    },
    created() {
      let uri = window.location.search.substring(1)
      let params = new URLSearchParams(uri)
      let id = params.get('version')
      if (id == 2) {
        this.version = 2
      }
    },
    methods: {
      track(label) {
        window.ad10Resources?.trackAction(`${this.resourcesId}-${label}`)
      },
    },
  }
</script>

<style lang="scss">
  @import "node_modules/minireset.css/minireset";
  // @import '@/scss/fonts.scss';
  @import '@/scss/variables.scss';
  @import '@/scss/mixins.scss';

  :root {
    --footer-height: 3rem;
    @include d {
      --footer-height: 4.25rem;
    }
  }

  html {
    font-family: $font, sans-serif;
    font-size: 16px;
    font-weight: $weight;
    color: $color-text;
    text-align: left;
    line-height: 1.3;
    @include desktop {
      font-size: 1.48vw;
    }
    @media (min-width: $width) {
      font-size: 16px;
    }
  }
  #app {
    position: relative;
    width: $width;
    max-width: 100%;
    margin: 0 auto;
    background: $color-bg;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    padding-bottom: var(--footer-height);
  }

  img {
    display: block;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  p {
    font-size: 1rem;
  }
  button {
    font-family: $font;
    font-size: 1rem;
    padding: 0;
    border: 0;
    background: none;
    outline: 0 none;
    cursor: pointer;
  }

</style>

<style scoped lang="scss">
  @import '@/scss/variables.scss';
  @import '@/scss/mixins.scss';

  .section-video {
    position: relative;
    .logo {
      position: absolute;
        top: 1rem;
        left: 1rem;
        width: 7rem;
      @include d {
        top: 1.75rem;
        left: 2rem;
        width: 16.1875rem;
      }
    }
  }

  .section-main {
    position: relative;
    .heading {
      position: absolute;
      left: 10%;
      top: 1rem;
      width: 80%;
      font-size: 1.25rem;
      font-weight: 600;
      color: #fff;
      text-align: center;
      text-shadow: 0 .125rem .5rem rgba(0, 0, 0, 0.5);
      @include d {
        top: 4.25rem;
        font-size: 2rem;
        text-shadow: 0 .125rem .5rem rgba(0, 0, 0, 0.30);
      }
    }
  }

  .section-usp {
    padding: 1rem 1rem 3rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    @include d {
      flex-wrap: nowrap;
      padding: 2rem 7.5rem 2.5rem;
    }
    .item {
      width: 50%;
      text-align: center;
      @include d {
        width: 12.5rem;
      }
      .title {
        display: block;
        margin-bottom: .25rem;
        font-size: 0.6875rem;
        font-weight: 500;
        @include m {
          display: flex;
          justify-content: center;
          align-items: flex-end;
          min-height: 3rem;
        }
      }
      .value {
        font-size: 2.25rem;
        font-weight: 500;
      }
      .unit {
        font-size: 1.5rem;
      }
    }
  }

  .section-tiles {
    margin-top: 1rem;
    @include d {
      margin-top: 4.5rem;
    }
    .tile {
      @include d {
        display: flex;
        &:nth-child(odd) {
          flex-direction: row-reverse;
        }
        .image,
        .text {
          width: 50%;
        }
      }
    }
    .text {
      padding: 2rem 1.5rem 2rem;
      @include d {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding: 1rem 5rem 1rem 3.75rem;
      }
      .title {
        margin-bottom: .75rem;
        font-size: 1.5rem;
        font-weight: 500;
        @include d {
          margin-bottom: 1.25rem;
          font-size: 2rem;
        }
      }
      p {
        font-size: 1rem;
        @include d {
          font-size: 1.25rem;
          margin-right: 2rem;
        }
      }
      .note {
        margin-top: 1rem;
        font-size: 75%;
      }
      .cta {
        display: inline-block;
        padding: .5rem 1.25rem;
        margin-top: 1rem;
        align-self: flex-end;
        font-size: 1rem;
        border: 1px solid #000;
        border-radius: 2rem;
        transition: .15s;
        @include d {
          padding: .75rem 1.25rem;
          margin-top: 5rem;
          font-size: 1.25rem;
        }
        &:hover {
          background: $color-text;
          color: #fff;
        }
      }
    }
    .image {
      overflow: hidden;
      img {
        display: block;
        width: 100%;
        max-width: none;
        transition: transform .4s;
      }
      &:hover {
        img {
          transform: scale(1.03);
        }
      }
    }
  }

  .section-info {
    padding: 5rem 1.5rem 6rem;
    background: url('assets/image-4.jpg') no-repeat center center / cover;
    @include d {
      padding: 12.625rem 1.5rem 13.5rem;
    }
    .heading {
      max-width: 26.875rem;
      margin: 0 auto 1.5rem;
      font-size: 1.5rem;
      font-weight: 500;
      color: #fff;
      text-align: center;
      @include d {
        font-size: 1.875rem;
      }
    }
    .items {
      display: flex;
      justify-content: center;
      @include m {
        flex-direction: column;
        align-items: center;
      }
      a {
        display: inline-flex;
        align-items: center;
        padding: .5rem 1rem;
        font-size: 1rem;
        color: #fff;
        border: 1px solid #fff;
        border-radius: 2rem;
        transition: background .15s;
        @include d {
          font-size: 1.125rem;
        }
        &:hover {
          background: rgba(#fff, .3);
        }
        &::before {
          content: '';
          width: 1rem;
          height: 1.25rem;
          margin-right: .5rem;
          @include d {
            width: 1.375rem;
            height: 1.75rem;
            margin-right: .625rem;
          }
        }
        &.download {
          &::before {
            background: url('assets/icons/document.svg') no-repeat center center / contain;
          }
        }
        &.find {
          &::before {
            background: url('assets/icons/location.svg') no-repeat center center / contain;
          }
        }
        &.book {
          &::before {
            background: url('assets/icons/tire.svg') no-repeat center center / contain;
          }
        }
      }
      a + a {
        margin-top: 1.25rem;
        @include d {
          margin-top: 0;
          margin-left: 1.25rem;
        }
      }
    }
  }

  .section-footer {
    .container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: var(--footer-height);
      padding: 0 1rem;
      background: #fff;
      @include d {
        padding: 0 2.25rem 0 2rem;
      }
    }
    &.sticky {
      position: fixed;
      left: 0;
      bottom: 0;
      z-index: 1000;
      width: 100%;
      .container {
        max-width: $width;
        margin: 0 auto;
      }
    }
    .logo {
      width: 8rem;
      @include d {
        width: 14.375rem;
      }
    }
    .model {
      width: 5rem;
      @include d {
        width: 9rem;
      }
    }
    .cta {
      padding: .5rem 1.25rem;
      font-size: 1rem;
      font-weight: 600;
      color: #fff;
      background: $color-1;
      border-radius: 3rem;
      transition: background .15s;
      img {
        display: inline-block;
        width: 5rem;
      }
      @include d {
        padding: .5rem 1.25rem;
        font-size: 1.75rem;
        &:hover {
          background: #cc0000;
        }
      }
    }
  }

</style>
